"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import type { ComponentProps } from "react";

import { toPublicPathname } from "@/utils/localeConstants";

import type BlogIndexTemplate from "@/templates/BlogIndex";
import {
  ReadableCopy,
  ReadableIndex,
  readableFallback,
} from "@/components/readable";

const BlogIndex = dynamic(() => import("@/templates/BlogIndex"), {
  ssr: false,
  loading: readableFallback("min-h-[600px]"),
});

export default function ClientOnlyBlogIndex(
  props: ComponentProps<typeof BlogIndexTemplate>,
) {
  const pathname = toPublicPathname(usePathname());

  return (
    <ReadableCopy
      copy={
        <ReadableIndex
          page={props.page}
          data={props.data}
          pageSize={props.pageSize}
          pageNumber={props.pageNumber}
          category={props.category}
          pageSort={props.pageSort}
          pathname={pathname}
          locale={props.locale ?? "en"}
          dict={props.dict}
          isBlog
        />
      }
    >
      <BlogIndex {...props} />
    </ReadableCopy>
  );
}
